import { createContext, useContext } from 'react'

// Who is signed in, their roles, the approval counts App already polls,
// whether bin tracking is on, and which modules the company's plan has,
// so pages don't each ask the server again.
export const SessionContext = createContext({ user: null, roles: [], approvals: { po: 0, valuation: 0, counts: 0, inventory: 0 }, binTracking: false, measurements: false, modules: [], has: () => true, refreshSettings: async () => {} })

export const useSession = () => useContext(SessionContext)

// The modules a plan can have, and what each one is called in the apps.
export const MODULE_NAMES = {
  invoices: 'Invoices',
  production: 'Production',
  jobs: 'Jobs',
  pos: 'POS',
  purchase: 'Purchase',
  inventory: 'Inventory',
  detailed_inventory: 'Detailed inventory',
  expenses: 'Expenses',
  accounting: 'Accounting',
}

/** True when the company's plan has `module`, or one of 'a|b' (an unknown list means everything). */
export const hasModule = (modules, module) => !Array.isArray(modules) || String(module).split('|').some((m) => modules.includes(m))

/** Quotes and invoices only on a job: Jobs without the Invoices add-on. */
export const jobsOnly = (modules) => Array.isArray(modules) && modules.includes('jobs') && !modules.includes('invoices')

/** Jobs only and no POS: Sales is just customer payments (quotes and invoices are made on the job). */
export const paymentsOnly = (modules) => jobsOnly(modules) && !modules.includes('pos')
